/* AagamStuti search filters. Plain JavaScript, no libraries. Linked by the header section, after aagamstuti.js and aagamstuti-search.js.
   - The round search button in the header pill now runs the search when an occasion, budget or In stock was picked (before, it only reopened the sheet).
   - The sheet shows "Show results" and "Clear filters" as soon as something is picked.
   - An occasion that has a collection link opens that collection, with the budget and In stock choices added, so the results are exact and not a keyword guess.
   - A budget or In stock choice with no search words opens the whole shop with those filters, instead of a search for "*".
   - The header remembers what is applied: on a page whose address carries a price band, In stock or an occasion collection, the matching chips and pill words are set. */
(function () {
  'use strict';
  if (window.__asFiltersBoot) return;
  window.__asFiltersBoot = true;

  var doc = document;
  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }

  var sheet = $('#search-overlay');
  var form = $('[data-search-form]');
  var input = $('[data-search-input]');
  if (!sheet || !form) return;
  var row = $('[data-apply-row]', sheet);
  var dirty = false; /* true once the shopper has picked something that is not applied yet */

  function pressed(sel) { return $(sel + '[aria-pressed="true"]', sheet); }
  function active() { return !!(pressed('[data-occasion]') || pressed('[data-budget]') || pressed('[data-instock]')); }
  function typed() { return input ? input.value.trim() : ''; }
  function send() { if (form.requestSubmit) form.requestSubmit(); else form.submit(); }

  /* The pill shows the occasion by name, not by its search words */
  function refresh() {
    var occ = pressed('[data-occasion]');
    $$('[data-seg-occasion]').forEach(function (n) { n.textContent = occ ? occ.textContent.trim() : 'Any occasion'; });
    var on = active();
    if (row) row.hidden = !on;
    $$('.as-sp .as-orb').forEach(function (b) { b.setAttribute('aria-label', dirty && on ? 'Search with these filters' : 'Search'); });
  }

  /* Where the filters lead when there are no search words */
  function address() {
    var occ = pressed('[data-occasion]'), bud = pressed('[data-budget]'), stock = pressed('[data-instock]');
    var href = occ ? (occ.getAttribute('data-href') || '') : '';
    var base = href || sheet.getAttribute('data-all-url') || '/collections/all';
    var params = [];
    if (!/^\/pages\//.test(base)) {
      if (bud) {
        var lo = bud.getAttribute('data-min') || '', hi = bud.getAttribute('data-max') || '';
        if (lo && lo !== '0') params.push('filter.v.price.gte=' + encodeURIComponent(lo));
        if (hi) params.push('filter.v.price.lte=' + encodeURIComponent(hi));
      }
      if (stock) params.push('filter.v.availability=1');
    }
    return base + (params.length ? (base.indexOf('?') > -1 ? '&' : '?') + params.join('&') : '');
  }

  /* True when the filters alone decide the page (no search words, and no occasion that needs a keyword search) */
  function filtersOnly() {
    if (typed()) return false;
    var occ = pressed('[data-occasion]');
    if (occ && !occ.getAttribute('data-href')) return false;
    return active();
  }

  function apply() {
    if (filtersOnly()) { window.location.href = address(); return; }
    send();
  }

  function clearAll() {
    /* Click the lit chips so aagamstuti.js and aagamstuti-search.js reset their own state too */
    $$('[data-occasion][aria-pressed="true"], [data-budget][aria-pressed="true"], [data-instock][aria-pressed="true"]', sheet).forEach(function (b) { b.click(); });
    dirty = false;
    refresh();
  }

  /* Enter in the box, or the round button inside the sheet */
  form.addEventListener('submit', function (e) {
    if (!filtersOnly()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.href = address();
  }, true);

  /* Capture phase, so the pill's round button is handled before it only reopens the sheet */
  doc.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('.as-sp .as-orb') && dirty && active()) { e.preventDefault(); e.stopPropagation(); apply(); return; }
    if (t.closest('[data-filters-apply]')) { apply(); return; }
    if (t.closest('[data-filters-clear]')) { clearAll(); }
  }, true);

  /* After aagamstuti.js has lit or dimmed a chip */
  doc.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest || !t.closest('[data-occasion], [data-budget], [data-instock]')) return;
    if (e.isTrusted) dirty = true;
    setTimeout(refresh, 0);
  });

  /* Set the chips from the page address */
  function restore() {
    var sp, path = window.location.pathname.replace(/\/$/, '');
    try { sp = new URLSearchParams(window.location.search); } catch (err) { return; }
    var gte = sp.get('filter.v.price.gte') || '', lte = sp.get('filter.v.price.lte') || '';
    if (gte === '0') gte = '';
    if (gte || lte) {
      $$('[data-budget]', sheet).some(function (b) {
        var lo = b.getAttribute('data-min') || '', hi = b.getAttribute('data-max') || '';
        if (lo === '0') lo = '';
        if (lo === gte && hi === lte) { b.click(); return true; }
        return false;
      });
    }
    if (sp.get('filter.v.availability') === '1') { var st = $('[data-instock]', sheet); if (st) st.click(); }
    $$('[data-occasion][data-href]', sheet).some(function (o) {
      var h = o.getAttribute('data-href').split('?')[0].replace(/\/$/, '');
      if (h && h === path) { o.click(); return true; }
      return false;
    });
    dirty = false;
    refresh();
  }
  restore();
})();
